// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__hUV6J","sidebar":"Sidebar_sidebar__7UX4L","backdrop":"Sidebar_backdrop__uAThX"};